module.exports = __webpack_public_path__ + "img/application_icon.a5e7ba17.svg";